import React, { useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { Container } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import {
  AagencyLogin,
  GetAagencyUserDetails,
  GetRolePermissions
} from '../../apis/Agency';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import {
  setAgencyAdminDetails,
  setIsAdmin,
  setLoginAgencyID,
  setPasswordRedux,
  setUserColumnOrder,
  setUserColumnVisibility,
  setUserDetailsObj,
  setUserRolePermissionsArr,
  setUserToken
} from '../../Redux/UserSlice';
import { useDispatch } from 'react-redux';
import {
  Typography,
  TextField,
  IconButton,
  Button,
  InputAdornment,
  Grid,
  Avatar
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '../ExtraPages/Login.css';
import { base_url, base_logo_url } from '../../apis/constants';

const LockScreenComponent = props => {
  const rememberMeRedux = useSelector(state => state.userDetails.rememberMe);
  const rememberMePassword = useSelector(state => state.userDetails.password);
  const AgencyAdminDetails = useSelector(state => state.user.AgencyAdminDetails);

  const [isPasswordError, setIsPasswordError] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword(show => !show);
  const handleMouseDownPassword = event => event.preventDefault();

  const CurrentURL = props?.location?.state?.currentRoute;
  const selectedModuleName = props?.location?.state?.selectedModuleName;

  sessionStorage.setItem('selectedModulePersist', selectedModuleName);
  const dispatch = useDispatch();
  const [newPassword, setNewPassword] = useState();
  const userDetails = useSelector(state => state.userDetails);
  const userDetailsToShow = useSelector(
    state => state.user.UserDetailsObj.userInfo
  );
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    if (rememberMeRedux && !newPassword) {
      setNewPassword(rememberMePassword);
    }
  }, [rememberMeRedux]);

  const GetSuccessUserDetails = (apiRes, status) => {
    dispatch(setIsAdmin(apiRes.data.isAdmin));
    dispatch(setUserDetailsObj(apiRes.data));
    dispatch(setUserColumnOrder(apiRes.data.userSettings.SHIPMENT_GRID_ORDER));
    dispatch(
      setUserColumnVisibility(apiRes.data.userSettings.SHIPMENT_GRID_COLUMNS)
    );
    dispatch(
      setAgencyAdminDetails({
        userAvatar: apiRes.data.userInfo.avatar,
        agencyName: apiRes.data.agencyName
      })
    );
    if (status === 'locked_login') {
      handleGetUserPermissionsRequest(apiRes);
    }
  };

  const RedirectToURL = () => {
    if (userDetails.isAdmin) {
      if (CurrentURL === '/get-rates' || CurrentURL === '/quick-quote') {
        return history.push('/quick-quote');
      } else if (
        CurrentURL.includes('/bookshipmen') ||
        CurrentURL === '/import-csv'
      ) {
        return history.push('/manage-shipments');
      } else if (CurrentURL) {
        return history.push(CurrentURL);
      } else {
        return history.push('/manage-shipments');
      }
    } else {
      return history.push(CurrentURL);
    }
  };

  const handleGetUserPermissionsRequest = apiRes => {
    GetRolePermissions(apiRes.data.userInfo.roleId)
      .then(res => {
        res.status === 200 &&
          dispatch(
            setUserRolePermissionsArr(
              res.data?.data[0]?.permissions?.length > 0
                ? JSON.parse(res.data.data[0]?.permissions)
                : res.data.data
            )
          );
        setIsLoading(false);
        history.push(RedirectToURL());
      })
      .catch(err => {
        console.log(err, 'user permissions Err----->>>>');
        setIsLoading(false);
      });
  };

  const successResponse = succRes => {
    if (succRes.statusCode === 200) {
      dispatch(setPasswordRedux(newPassword));
      dispatch(setUserToken(succRes.token));
      dispatch(setLoginAgencyID(succRes.agencyId));
      sessionStorage.setItem('UserAuthToken', succRes.token);
      localStorage.setItem('tokenExpiryTime', succRes.expiry);
      document.cookie = 'userInfo=John Doe; path=/';
      setIsLoading(false);
      GetAagencyUserDetails(userDetails.email)
        .then(
          res =>
            res.data.statusCode === 200 &&
            GetSuccessUserDetails(res.data, 'locked_login')
        )
        .catch(err => console.log(err, 'GetAagencyUserDetails Err--'));
    }
  };

  const handleLogin = e => {
    e.preventDefault();
    setIsPasswordError(false);
    setPasswordError('');
    setIsLoading(true);
    AagencyLogin(userDetails.email, newPassword)
      .then(res => res.data.statusCode === 200 && successResponse(res.data))
      .catch(err => {
        setIsLoading(false);
        setIsPasswordError(true);
        setPasswordError(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    GetAagencyUserDetails(userDetails.email)
      .then(
        res => res.data.statusCode === 200 && GetSuccessUserDetails(res.data)
      )
      .catch(err => console.log(err, 'GetAagencyUserDetails Err--'));
  }, []);

  useEffect(() => {
    localStorage.clear();
    document.cookie =
      'userInfo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    dispatch(setUserToken(''));
    dispatch(setLoginAgencyID(''));
  }, []);

  const firstLetter = userDetailsToShow?.firstName
    ? userDetailsToShow.firstName.charAt(0).toUpperCase()
    : '';
  const lastLetter = userDetailsToShow?.lastName
    ? userDetailsToShow.lastName.charAt(0).toUpperCase()
    : '';

  return (
    <React.Fragment>
      <MetaTags>
        <title>
          {base_url === 'https://beta.api.shiptechpro.com/'
            ? 'LockScreen | Shiptechpro'
            : 'LockScreen | TMS Shipping'}
        </title>
      </MetaTags>
      <ToastContainer
        position='top-center'
        style={{ width: 'auto' }}
        autoClose={4800}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Background image — same as SignIn & ResetPassword */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundImage: `url(${base_logo_url}carrier_logos/TMS-backg-img.png)`,
          backgroundSize: '100% 110%',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0
        }}
      />

      <div style={{ position: 'relative', zIndex: 1 }}>
        <section
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Container fluid>
            <Grid
              container
              sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: { xs: 2, sm: 4 }
              }}
            >
              <Grid
                item
                xs={12}
                sm={7}
                md={5}
                lg={4}
                xl={3}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(255,255,255,0.97)',
                  borderRadius: '16px',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                  padding: { xs: '32px 20px', sm: '48px 36px' },
                  minHeight: '410px'
                }}
              >
                <div style={{ width: '100%' }}>
                  {/* Logo — same SVG as SignIn */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: -20,
                      marginBottom: 20
                    }}
                  >
                    <svg
                      width='240'
                      height='62'
                      viewBox='0 0 1080 360'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <defs>
                        <linearGradient
                          id='lockLogoGrad'
                          x1='82'
                          y1='72'
                          x2='288'
                          y2='278'
                          gradientUnits='userSpaceOnUse'
                        >
                          <stop offset='0' stopColor='#1297FF' />
                          <stop offset='1' stopColor='#006CFF' />
                        </linearGradient>
                      </defs>
                      <g
                        transform='translate(38 20) scale(.625)'
                        stroke='url(#lockLogoGrad)'
                        strokeWidth='54'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        fill='none'
                      >
                        <path d='M176 108 L256 188 L336 108' />
                        <path d='M108 176 L188 256 L108 336' />
                        <path d='M336 404 L256 324 L176 404' />
                        <path d='M404 336 L324 256 L404 176' />
                      </g>
                      <text
                        x='365'
                        y='220'
                        fill='#000000'
                        fontFamily='Inter, Arial, Helvetica, sans-serif'
                        fontSize='118'
                        letterSpacing='-4'
                      >
                        <tspan fontWeight='700'>Ship</tspan>
                        <tspan fontWeight='400'>TechPro</tspan>
                      </text>
                    </svg>
                  </div>

                  {/* User avatar + name */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      marginBottom: '16px'
                    }}
                  >
                    <Avatar
                      src={
                        AgencyAdminDetails?.userAvatar
                          ? base_logo_url + AgencyAdminDetails.userAvatar
                          : undefined
                      }
                      sx={{
                        width: 64,
                        height: 64,
                        bgcolor: '#3361FF',
                        fontSize: '22px',
                        fontWeight: 700,
                        mb: 1
                      }}
                    >
                      {firstLetter + lastLetter}
                    </Avatar>
                    <Typography variant='h6' style={{ fontWeight: 600 }}>
                      {userDetailsToShow?.firstName}{' '}
                      {userDetailsToShow?.lastName}
                    </Typography>
                  </div>

                  <Typography
                    variant='body2'
                    style={{
                      textAlign: 'center',
                      color: '#666',
                      marginBottom: '20px'
                    }}
                  >
                    Enter your password to continue
                  </Typography>

                  <Form style={{ width: '100%' }}>
                    <div style={{ marginBottom: '20px' }}>
                      <Typography
                        variant='caption'
                        style={{ fontWeight: 600, color: '#333' }}
                      >
                        Password <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        error={isPasswordError}
                        id='newPassword'
                        type={showPassword ? 'text' : 'password'}
                        value={newPassword}
                        onChange={e => setNewPassword(e.target.value)}
                        placeholder='Enter your password'
                        variant='outlined'
                        size='small'
                        required
                        helperText={passwordError}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              <LockOutlinedIcon
                                style={{ color: '#aaa', fontSize: 20 }}
                              />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                aria-label='toggle password visibility'
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge='end'
                                size='small'
                              >
                                {showPassword ? (
                                  <VisibilityOff style={{ fontSize: 20 }} />
                                ) : (
                                  <Visibility style={{ fontSize: 20 }} />
                                )}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        style={{ marginTop: '6px' }}
                      />
                    </div>

                    <Button
                      fullWidth
                      disabled={!newPassword}
                      type='submit'
                      variant='contained'
                      onClick={e => handleLogin(e)}
                      style={{
                        borderRadius: '8px',
                        padding: '6px',
                        fontSize: '16px',
                        fontWeight: 600,
                        textTransform: 'none'
                      }}
                    >
                      {isLoading ? 'Loading...' : 'Login'}
                    </Button>
                  </Form>
                </div>
              </Grid>
            </Grid>
          </Container>

          {/* Footer — same as SignIn */}
          <div
            style={{ position: 'fixed', bottom: '8px' }}
            className='w-100 px-3'
          >
            <Grid
              container
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Grid
                item
                md={5}
                lg={5}
                className='login-footer-cols'
                style={{ display: 'flex' }}
              />
              <Grid
                item
                md={6}
                lg={5}
                className='login-footer-cols'
                style={{ display: 'flex', justifyContent: 'end' }}
              >
                <div className='login-footer-notes'>
                  <span className='login-footer-link1 mx-2'>
                    <div className='d-inline-block'>
                      <EmailOutlinedIcon style={{ height: 16, width: 18 }} />
                      {base_url === 'https://api.tms.dynamicwerx.com/' ? (
                        <a
                          className='login-footer-link1'
                          href={'mailto:support@dynamicwerx.com'}
                        >
                          support@dynamicwerx.com
                        </a>
                      ) : (
                        <a
                          className='login-footer-link1'
                          href={'mailto:support@shiptechpro.com'}
                        >
                          support@shiptechpro.com
                        </a>
                      )}
                    </div>
                  </span>
                </div>
              </Grid>
            </Grid>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default LockScreenComponent;
